import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule, TabsModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AddEditCandidateContactOneModule } from 'src/app/shared/add-edit-candidate-contact-one/add-edit-candidate-contact-one.module';
import { CandidateAdditionalDetailsModule } from 'src/app/shared/candidate-additional-details/candidate-additional-details.module';
import { CandidateProfileComponent } from './candidate-profile.component';

@NgModule({
  declarations: [CandidateProfileComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    TabsModule.forRoot(),
    PipesModule,
    AddEditCandidateContactOneModule,
    CandidateAdditionalDetailsModule
  ],
  entryComponents: [CandidateProfileComponent],
  exports: [CandidateProfileComponent]
})
export class CandidateProfileModule { }
